import React, {useEffect, useState} from 'react';
import {Button, Form, Modal} from 'react-bootstrap';

const SaveConfigModal = ({show, title, onConfirm, onHide}) => {
  const [note, setNote] = useState('');

  useEffect(() => {
    if (show) setNote('');
  }, [show]);

  const handleConfirm = () => {
    onConfirm(note.trim());
  };

  return (
    <Modal show={show} onHide={onHide} size="sm" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Note <span className="text-muted fw-normal">(optional)</span></Form.Label>
          <Form.Control
            autoFocus
            as="textarea"
            rows={2}
            maxLength={200}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="e.g. increased charge limit to 16A"
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        <Button className="button-accent" onClick={handleConfirm}>Confirm</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SaveConfigModal;
